// Screen-capture protection is native-only
export const useSecureScreen = () => {}
